import { Chip } from "@mui/material";

const toneForStatus = (statusTitle = "", status) => {
  const text = String(statusTitle || status || "").toLowerCase();
  if (
    text.includes("فعال") ||
    text.includes("active") ||
    text.includes("تأیید") ||
    text.includes("approved") ||
    text.includes("تکمیل")
  ) {
    return "success";
  }
  if (
    text.includes("لغو") ||
    text.includes("cancel") ||
    text.includes("رد") ||
    text.includes("reject")
  ) {
    return "error";
  }
  if (
    text.includes("انتظار") ||
    text.includes("pending") ||
    text.includes("در حال") ||
    text.includes("progress")
  ) {
    return "warning";
  }
  return "default";
};

const ContractorStatusBadge = ({ status, statusTitle, label, size = "small" }) => {
  const display = label || statusTitle || (status != null ? String(status) : "—");
  return (
    <Chip
      size={size}
      color={toneForStatus(statusTitle, status)}
      label={display}
      variant="outlined"
      data-testid="contractor-status-badge"
    />
  );
};

export default ContractorStatusBadge;
